export default __webpack_public_path__ + "static/media/favicon.e01640f2.ico";